<div class="entry-content">
  <div class="wpb-content-wrapper">
    <app-home-slider />

    <div class="container">
      <div class="vc_row wpb_row vc_row-fluid vc_custom_1455195117811">
        <div class="wpb_column vc_column_container vc_col-sm-12">
          <div class="vc_column-inner">
            <div class="wpb_wrapper">
              <div
                class="wpb_text_column wpb_content_element color-scheme-light vc_custom_1715046271470"
              >
                <div class="wpb_wrapper">
                  <h6
                    style="text-align: center; line-height: 1.6; letter-spacing: 1.5px; font-size: 14px; margin: 0"
                  >
                    SAVE UP TO 25% ON FRAGANCE OIL!
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="vc_row wpb_row vc_row-fluid vc_custom_1458063964106">
        <div class="wpb_column vc_column_container vc_col-sm-12">
          <div class="vc_column-inner">
            <div class="wpb_wrapper">
              <div
                class="title-wrapper basel-title-color-default basel-title-style-cross basel-title-size-default text-center vc_custom_1708520839395"
              >
                <span class="title-subtitle font-default">FRAGANCES AND MACHINES</span>
                <div class="liner-continer">
                  <span class="left-line"></span>
                  <h4 class="title">
                    FEATURED PRODUCTS<span class="title-separator"><span></span></span>
                  </h4>
                  <span class="right-line"></span>
                </div>
              </div>

              <div
                class="basel-products-element"
                (mouseenter)="featuredHover.set(true)"
                (mouseleave)="featuredHover.set(false)"
              >
                <div
                  class="products elements-grid row basel-products-holder pagination-arrows grid-columns-4"
                >
                  @for (item of featured(); track item.id) {
                    <app-product-card [product]="item" (add)="add($event)" />
                  }
                </div>
                <div class="products-footer" [class.show-arrow]="featuredHover()">
                  <a
                    href="#"
                    rel="nofollow"
                    class="btn basel-products-load-prev"
                    [class.disabled]="!featuredHasPrev()"
                    (click)="featuredPrev($event)"
                    >Load previous products</a
                  >
                  <a
                    href="#"
                    rel="nofollow"
                    class="btn basel-products-load-next"
                    [class.disabled]="!featuredHasNext()"
                    (click)="featuredNext($event)"
                    >Load next products</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="vc_row wpb_row vc_row-fluid vc_row-flex vc_row-o-content-middle vc_row-has-fill about-bg vc_custom_1708381729525"
    >
      <div class="wpb_column vc_column_container vc_col-sm-12">
        <div class="vc_column-inner">
          <div class="wpb_wrapper">
            <div
              class="vc_row wpb_row vc_inner vc_row-fluid text-center vc_custom_1455194261836"
            >
              <div class="wpb_column vc_column_container vc_col-sm-6">
                <div class="vc_column-inner vc_custom_1453812054824">
                  <div class="wpb_wrapper">
                    <div
                      class="wpb_single_image wpb_content_element vc_align_center vc_custom_1708896441288 mb-3"
                    >
                      <figure class="wpb_wrapper vc_figure">
                        <div class="vc_single_image-wrapper">
                          <img
                            src="/basel/media/logo.png"
                            alt="Diffuser Dreams"
                            width="218"
                            height="131"
                          />
                        </div>
                      </figure>
                    </div>
                    <div class="wpb_text_column wpb_content_element vc_custom_1708375897727">
                      <div class="wpb_wrapper">
                        <p style="color: #676767; font-size: 14px; letter-spacing: 1.5px">
                          FRAGANCE OILS AND DIFFUSER MACHINES STORE
                        </p>
                      </div>
                    </div>
                    <div class="wpb_text_column wpb_content_element vc_custom_1708375938443">
                      <div class="wpb_wrapper">
                        <p>
                          We're passionate about transforming spaces into havens of tranquility and
                          delight. Specializing in premium diffuser machines and exquisite fragrance
                          oils, we invite you to embark on a sensory journey like no other.
                        </p>
                      </div>
                    </div>
                    <div class="basel-button-wrapper text-center">
                      <a class="btn btn-color-black btn-style-default btn-size-small" routerLink="/shop"
                        >SHOP NOW</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="wpb_column vc_column_container vc_col-sm-6 vc_hidden-xs">
                <div class="vc_column-inner vc_custom_1453812061167">
                  <div class="wpb_wrapper">
                    <div class="wpb_text_column wpb_content_element vc_custom_1446294282303">
                      <div class="wpb_wrapper">
                        <h3 class="font-alt" style="margin: 0">About the shop</h3>
                      </div>
                    </div>
                    <div class="vc_icon_element vc_icon_element-outer vc_custom_1446294354454">
                      <div class="vc_icon_element-inner vc_icon_element-color-black vc_icon_element-align-center">
                        <span class="vc_icon_element-icon dd-heart-icon" aria-hidden="true"></span>
                      </div>
                    </div>
                    <div class="wpb_text_column wpb_content_element vc_custom_1708375704518">
                      <div class="wpb_wrapper">
                        <p>
                          Explore an array of diffuser machines and fragrant oils at our store,
                          where quality meets elegance in every product. Elevate your space with our
                          curated selection and indulge in a sensory journey unlike any other.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="vc_row wpb_row vc_row-fluid vc_row-o-content-middle vc_custom_1485260379029">
        <div class="wpb_column vc_column_container vc_col-sm-6">
          <div class="vc_column-inner">
            <div class="wpb_wrapper">
              <div
                class="title-wrapper basel-title-color-black basel-title-style-cross basel-title-size-default text-center"
              >
                <div class="liner-continer">
                  <span class="left-line"></span>
                  <h4 class="title">
                    WHAT THEY SAY ABOUT US<span class="title-separator"><span></span></span>
                  </h4>
                  <span class="right-line"></span>
                </div>
              </div>
              <div class="testimonials-wrapper">
                <div
                  class="testimonials testimonials-slider testimon-style-standard testimon-columns-3 testimon-align-center"
                >
                  <div class="testimonial">
                    <div class="testimonial-inner">
                      <div class="testimonial-avatar">
                        <img
                          class="testimonial-avatar-image"
                          src="/basel/media/home/testimonials-placeholder.jpg"
                          width="100"
                          height="100"
                          alt="testimonials-placeholder"
                        />
                      </div>
                      <div class="testimonial-content">
                        <div class="testimonial-rating">
                          <span class="star-rating"><span style="width: 100%"></span></span>
                        </div>
                        Fringilla iaculis ante torquent a diam a vestibulum diam nisi augue dictumst
                        parturient a vestibulum tortor viverra inceptos adipiscing nec a
                        ullamcorper.Ullamcorper aliquam rutrum.
                        <footer>
                          John Doe
                          <span>Happy Customer</span>
                        </footer>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="wpb_column vc_column_container vc_col-sm-6">
          <div class="vc_column-inner">
            <div class="wpb_wrapper">
              <div class="promo-banner-wrapper">
                <div
                  class="promo-banner text-right vertical-alignment-bottom banner- hover-1 color-scheme-light"
                >
                  <div class="main-wrapp-img">
                    <div class="banner-image">
                      <img
                        class="promo-banner-image image-1"
                        src="/basel/media/home/promo-banner.png"
                        width="800"
                        height="600"
                        alt="diffuser"
                      />
                    </div>
                  </div>
                  <div class="wrapper-content-baner">
                    <div class="banner-inner">
                      <h6 style="margin-bottom: 10px">
                        <span style="color: #a6a6a6">DIFFUSER DREAMS</span>
                      </h6>
                      <h3 style="margin-bottom: 10px">
                        <strong>EXPERIENCE THE POWER OF FRAGANCE WITH US!</strong>
                      </h3>
                      <p>Join us in embracing the art of scenting and embark on a sensory adventure</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
